export class Accordeon {
  constructor() {
    var allBtn = document.querySelectorAll('.js-accordeon-button')
    if (allBtn) {
      for (let i = 0; i < allBtn.length; i++) {
        allBtn[i].addEventListener('click', function (evt) {
          let accordeon = allBtn[i].parentNode.parentNode.querySelector('.js-accordeon-container');
          allBtn[i].classList.toggle('active');
          accordeon.classList.toggle('active');
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./js/util/accordeon.js